/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum JustifyModalAliases {
  BUTTON_CANCEL = 'button-cancel',
  BUTTON_DISABLE = 'button-disable',
  FIELD_JUSTIFY = 'field-justify',
  FORM_JUSTIFY = 'form-justify',
  INPUT_JUSTIFY = 'input-justify',
  LAYOUT_JUSTIFY = 'layout-justify',
  PANEL_DISABLE = 'panel-disable',
  PANEL_JUSTUFY = 'panel-justufy',
  PANEL_PRIMARY = 'panel-primary',
  PANEL_RIGHT = 'panel-right',
  PANEL_TITLE = 'panel-title',
  TEXT_TITLE = 'text-title',
}
export { JustifyModalAliases };
